import { Injectable } from '@angular/core';

import { firstValueFrom } from 'rxjs';

import { LocalStorageService } from '@mirage-projects/cw-commons';
import { DbPcvizService, UtilsPcvizService } from '@mirage-projects/cw-pcviz-core';

/**
 * This service manages some of the external events without having the project opened
 */
@Injectable({ providedIn: 'root' })
export class ScanHelperService {
    readonly CONNECTED_STATE = 'CONNECTED';

    constructor(
        private localStorageService: LocalStorageService,
        private dbPcvizService: DbPcvizService,
        private utilsPcvizService: UtilsPcvizService
    ) {}

    async connectScan(state: string, type: string): Promise<void> {
        const isConnected = state === this.CONNECTED_STATE || false;
        this.localStorageService.setItem('scannerStatus', isConnected, true);
        this.localStorageService.setItem('scannerType', type, true);
        await firstValueFrom(this.utilsPcvizService.onControllersInitialized$);
        this.scanSelectionController.setScannerStatus(isConnected);
        this.scanSelectionController.setScannerType(type);
    }

    private get scanSelectionController(): any {
        return this.dbPcvizService.getControllerDB('ScanSelection');
    }
}
